import { DAYS_TO_MS } from '@utils/constants';

const timespanOptions = [{
  id: "day",
  label: "I dag"
}, {
  id: "two-days",
  label: "Siden i går"
}, {
  id: "week",
  label: "Seneste uge"
}, {
  id: "month",
  label: "Seneste måned"
}, {
  id: "year",
  label: "Seneste år"
}];
const DEFAULT_TIMESPAN = "month";
function timespanToMs(timespan) {
  switch (timespan) {
    case "day":
      return Date.now() - DAYS_TO_MS;
    case "two-days":
      return Date.now() - DAYS_TO_MS * 2;
    case "week":
      return Date.now() - DAYS_TO_MS * 7;
    case "month":
      return Date.now() - DAYS_TO_MS * 30;
    case "year":
      return Date.now() - DAYS_TO_MS * 365;
  }
}

export { DEFAULT_TIMESPAN, timespanOptions, timespanToMs };
//# sourceMappingURL=timespan.js.map
